import type { FeatureManifest } from '../registry.js';

/** SCR-14 collections: MT-07 Customer Book and MT-08 sticker album (sets, rewards, drop odds). */
export default {
  id: 'collections',
  flag: 'collections',
  online: true,
  provides: ['collections', 'stickerSet', 'stickerOdds', 'customerCard', 'stickerSetComplete'],
  entry: { order: 40, icon: 'ico_cur_sticker', label: 'feature.collections.rail', testId: 'rail-collections', open: 'collections' },
  art: ['customers_*', 'stickers_*'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
